import React, { useContext, useRef } from 'react';
import { store } from '../../App';
import { motion } from 'framer-motion';
import './IntroCards.scss';

export default function IntroCards() {
  const [state, dispatch] = useContext(store);
  const scrollRef = useRef(null);

  return (
    <div className="container-intro">
      <section
        className={`left-intro big-card ${
          state.darkmode ? 'dark-card' : 'light-card'
        }`}
      >
        <h3 className={`${state.darkmode ? 'dark-heading' : 'light-heading'}`}>
          {state.language === 'english'
            ? 'React-Entwickler an der Schnittstelle von Design und Code.'
            : 'React developer at the intersection between design and code'}
        </h3>
        <p className={`${state.darkmode ? 'dark-eyebrow' : 'light-eyebrow'}`}>
          {state.language === 'english'
            ? 'Begonnen mit HTML, CSS und JavaScript, habe ich mir Programmieren selbst beigebracht. Heute arbeite ich über Vanilla JS hinaus mit TypeScript in React.js, verwalte Zustände mit Redux oder Context, nutze SASS als CSS-Präprozessor und entwickle Backend-Lösungen mit Node.js und MongoDB. Außerdem arbeite ich gern mit Motion-Libraries wie Framer Motion und erforsche Gen AI Chatbots.'
            : 'Starting with HTML, CSS, and JavaScript, I taught myself programming. Today, beyond vanilla JS, I work with TypeScript in React.js, manage state with Redux or Context, use SASS for CSS preprocessing, and build backend services with Node.js and MongoDB. I also enjoy integrating motion libraries like Framer Motion and exploring Gen AI chatbots.'}
        </p>
      </section>

      <section className="right-intro" ref={scrollRef}>
        <motion.div
          className={`small-card ${
            state.darkmode ? 'dark-card' : 'light-card'
          }`}
          initial={{ scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <div className="card-top">
            <h2 className="num green">
              {state.language === 'english' ? 'Zahlung' : 'Pay'}
            </h2>

            <h2 className="sign green-sign">🔐</h2>
          </div>
          <h4
            className={`${state.darkmode ? 'dark-eyebrow' : 'light-eyebrow'}`}
          >
            {state.language === 'english'
              ? `Integration von UPI, Karten- und Wallet-Zahlungen`
              : `Integrated UPI, cards, and digital wallet payments`}
          </h4>
        </motion.div>

        <motion.div
          className={`small-card ${
            state.darkmode ? 'dark-card' : 'light-card'
          }`}
          initial={{ scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
          viewport={{ once: true }}
        >
          <div className="card-top">
            <h2 className="num place blue">
              {state.language === 'english' ? 'KI' : ' AI'}
            </h2>
          </div>
          <h4
            className={`${state.darkmode ? 'dark-eyebrow' : 'light-eyebrow'}`}
          >
            {state.language === 'english'
              ? `Chatbots und intelligente Workflows`
              : `Chatbots and Intelligent Workflows`}
          </h4>
        </motion.div>

        <motion.div
          className={`small-card ${
            state.darkmode ? 'dark-card' : 'light-card'
          }`}
          initial={{ scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <div className="card-top">
            <h2 className="num purple">8</h2>
            <h2 className="sign purple-sign">+</h2>
          </div>
          <h4
            className={`${state.darkmode ? 'dark-eyebrow' : 'light-eyebrow'}`}
          >
            {state.language === 'english'
              ? 'Reale Anwendungen in Fintech, Gaming und ECM'
              : 'Real-world apps across fintech, gaming, and ECM'}
          </h4>
        </motion.div>

        <motion.div
          className={`small-card ${
            state.darkmode ? 'dark-card' : 'light-card'
          }`}
          initial={{ scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
          viewport={{ once: true }}
        >
          <div className="card-top">
            <h2 className="num red">☁️ Cloud</h2>
          </div>
          <h4
            className={`${state.darkmode ? 'dark-eyebrow' : 'light-eyebrow'}`}
          >
            {state.language === 'english'
              ? 'Bereitstellung skalierbarer Anwendungen auf AWS und Azure'
              : 'Deployed scalable apps using AWS and Azure services'}
          </h4>
        </motion.div>
      </section>
    </div>
  );
}
